import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import UserTypes from '../../utils/userTypes';
import { connect } from 'react-redux';
import { setUserType } from '../../redux/userAuthentication/userAuth.actions';
import { resetToken } from '../../redux/parentDashboard/parentDashboard.actions';
import { sidebarDetails } from '../../utils/const';

const SideBarElement = ({
	index,
	redirectLink,
	PageName,
	icon,
	isParent,
	setUserType,
	userType,
	allCourseDetails,
	resetToken,
}) => {

	const myCourses = []
	const freeCourses = []

	if (allCourseDetails.length > 0) {
		myCourses.length = 0
		freeCourses.length = 0
		allCourseDetails.map((item) => {
			if ((item.is_active === true || item.is_active === 1) && item.course_name !== 'free') {
				myCourses.push(item)
			} else if (item.course_name === 'free') {
				freeCourses.push(item)
			}
		})
	}

	return (
		<li>
			<NavLink
				to={redirectLink ? redirectLink : null}
				id={PageName}
				onClick={() => {
					if (!!isParent) {
						setUserType(UserTypes.Parent);
					} else if (userType !== UserTypes.Regular) {
						setUserType(UserTypes.Regular);
						resetToken();
					}
				}}
				activeClassName="active-menu"
				style={{
					backgroundImage: `url(${icon}.png)`,
					borderTopWidth: `${index === 0 ? '0' : '1px'}`
				}}
				activeStyle={{
					backgroundImage: `url(${icon}-active.png)`
				}}
				isActive={(match, location) => {

					if ((location.pathname === "/mycourse" || location.pathname === "/freeactivities") && PageName === "Free Activities" && freeCourses.length > 0) {

						if (localStorage.getItem('active_course_id') === (freeCourses[0]?.course_id)?.toString()) {
							return true
						} else {
							return false
						}
					} else if (match) {

						if (location.pathname === "/mycourse" && PageName === "My Courses" && freeCourses.length > 0) {
							if (localStorage.getItem('active_course_id') === (freeCourses[0]?.course_id)?.toString()) {
								return false
							} else {
								return true
							}
						} else {
							return true
						}
					}
				}}
			>
				{PageName}
			</NavLink>
		</li>
	);
};

const mapStateToProps = (state) => {
	const { userType } = state.rootReducer.loginDetails;
	const allCourseDetails = state.rootReducer.changeCourse.courseDetails;
	return {
		userType,
		allCourseDetails: allCourseDetails || null
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setUserType: (type) => dispatch(setUserType(type)),
		resetToken: () => dispatch(resetToken()),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(SideBarElement);
